import useAuth from '../../hooks/useAuth';
import { Outlet, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

const Layout = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  if (!isAuthenticated) {
    navigate('/login');
  }

  return (
    <div>
      <Navigation />
      <Outlet />
    </div>
  );
};

export default Layout;
